<style scoped="scoped" lang="scss"></style>

<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/production/plan/mergeList" getKey="rows" :columns="columns" @selectionChange="selectionChange">
      <!-- 搜索框插槽 -->
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item :label="$t('yixuanjihuadan')">
            {{ planId }}
          </el-form-item>
          <el-form-item :label="$t('kehedanchanpinbianma/mingcheng')">
            <yi_cross_select :max="1" :selectTitle="'code,name'" :component="'web_base_matter_list'" :ids.sync="yt.conditions.materialId" @getItems="getItems"> </yi_cross_select>
          </el-form-item>

          <el-form-item>
            <el-button @click="yt.get(1)" type="primary" plain="plain">
              {{ $t("sousuo") }}
            </el-button>
            <el-button @click="yt.clear((planId = ''))">{{ $t("chongzhi") }}</el-button>
            <yi_curd_expand_button></yi_curd_expand_button>
          </el-form-item>
        </el-form>
      </template>

      <!-- 右侧按钮插槽 -->
      <template #buttonsR>
        <!--<el-button size="mini" style="margin-right:1px" icon="yicon yicon-export" :title="$t('daochu')" @click="exportExcel()"> </el-button>-->
        <el-button size="mini" icon="yicon yicon-config_column" :title="$t('peizhilie')" @click="yt.showColumnsDialog()"></el-button>
      </template>
    </yi_curd_table>
  </div>
</template>
<script type="text/javascript">
export default {
  name: "web_order_management_production_plan_combine",
  components: {
    // work_bom
  },
  props: {
    // 生产配置-产品色号管理
    colorNoEnable: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      materialIdlist: [],
      materialIds: null,
      planIdList: [],
      planId: null,
      // 选中的行
      selectedRows: [],
      columns: [
        {
          label: "xuanze",
          type: "selection",
          align: "center",
          selectable: (row, index) => true
        },
        {
          label: "jihuadanhao",
          prop: "no",
          width: 130,
        },
        {
          label: "ERPgongdanhao",
          prop: "erpNo",
          width: 130,
        },
        {
          label: "chanpinbianma",
          prop: "material.code",
          width: 130,
        },
        {
          label: "chanpinmingcheng",
          prop: "material.name",
        },
        {
          label: "sehao",
          prop: "colorNo",
          show: this.colorNoEnable
        },
        {
          label: "jihuashuliang",
          prop: "quantity",
        },
        {
          label: "yipaichanshuliang",
          prop: "schedulingQuantity",
          width: 150,
        },
        {
          label: "guishuchejian",
          prop: "org.name",
        },
        {
          label: "zhuangtai",
          type: "tag",
          prop: "status",
          tags: {
            1: {
              color: "#E6A23C",
              text: this.$t("daipaichan"),
            },
            2: {
              color: "#67C23A",
              text: this.$t("yipaichan"),
            },
          },
        },
        {
          label: "jihuakaishishijian",
          prop: "startTime",
          type: "time",
          width: 150,
        },
        {
          label: "jihuawanchengshijian",
          prop: "endTime",
          type: "time",
          width: 150,
        },
        {
          label: "beizhu",
          prop: "remark",
        },
        // {
        // 	label: 'caozuo',
        // 	type: 'slot',
        // 	width: 130,
        // 	fixed: 'right'
        // },
      ],
    };
  },

  created() {
    setTimeout(() => {
      // if(this.materialId) {
      this.yt.conditions = {
        materialId: this.materialId,
        pageSize: 1000,
      };
      this.yt.get(1);
      this.yt.isShowPagination = false;
      // }
    }, 300);
  },
  methods: {
    selectionChange(items) {
      this.selectedRows = items;
      this.planIdList = items.map((item) => {
        return item.id;
      });
      this.planId = items
        .map((item) => {
          return item.no;
        })
        .join(",");
    },
    getItems(items) {
      this.materialIdlist = items;

      for (let i = 0; i < this.materialIdlist.length; i++) {
        this.materialId = this.materialIdlist[i]["id"];
      }
    },
  },
};
</script>
